module.exports = __webpack_public_path__ + "static/media/chrome.58d2fa44.svg";